module.exports = __webpack_public_path__ + "static/media/fullstack-icon.8a3df159.jpg";